import React from 'react';
import BmbCta from '../BmbCta';
import KmoCta from '../KmoCta';
import MkQr from '../MkQr';
import bmbIcon from '../../../assets/images/mk/mk-bmb-icon-192.webp';
import { kmoPlayHref } from '../../../marketing/links';
import { PLAY_FACTS } from '../../../marketing/facts';

const kmoLogo = require('../../../assets/images/logo-icon.svg').default;

// H11 — the last, largest install prompt. QR codes for desktop visitors only.
const HomeFinal = ({ platform }) => (
  <section className="mk-final section" id="get" aria-labelledby="mk-final-title">
    <div className="container">
      <div className="section-inner">
        <div id="mk-final-cta" className="mk-final__panel reveal-scale-up" data-reveal-offset="0">
          <div className="mk-final__head">
            <h2 id="mk-final-title" className="mk-h2">
              Your phone can wait.
            </h2>
            <p className="mk-lead">
              {`Keep Me Out has ${PLAY_FACTS.downloads} downloads on Google Play. Want a gentler nudge, or use an iPhone? Try Bring Me Back.`}
            </p>
          </div>
          <div className="mk-final__cols">
            <div className="mk-final__col reveal-from-bottom" data-reveal-offset="0" data-reveal-delay="0">
              <div className="mk-card mk-final__card">
                <span className="mk-final__icon mk-final__icon--kmo">
                  <img src={kmoLogo} alt="" width={36} height={36} />
                </span>
                <h3 className="mk-h3">Keep Me Out</h3>
                <p className="mk-body mk-final__line">
                  Lock your phone for a set time · Android 6.0 and up · Free to download
                </p>
                <KmoCta placement="home_final" platform={platform} showMeta={false} />
                <MkQr
                  platform={platform}
                  value={kmoPlayHref('home_final_qr')}
                  title="QR code to Keep Me Out on Google Play"
                  caption="Scan with your Android phone to open Keep Me Out on Google Play."
                />
              </div>
            </div>
            <div className="mk-final__col reveal-from-bottom" data-reveal-offset="0" data-reveal-delay="120">
              <div className="mk-card mk-final__card mk-final__card--bmb">
                <img className="mk-final__icon" src={bmbIcon} alt="" width={64} height={64} loading="lazy" decoding="async" />
                <h3 className="mk-h3">Bring Me Back</h3>
                <p className="mk-body mk-final__line">
                  A gentle pause before distracting apps · iPhone and Android · Free to download
                </p>
                <BmbCta variant="button" placement="home_final" platform={platform} />
                <MkQr
                  platform={platform}
                  value="https://keepmeout.app/bring-me-back"
                  title="QR code to the Bring Me Back page"
                  caption="Scan with your phone — the page shows the right store."
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HomeFinal;
